__turbopack_context__.v({
  "className": "geist_mono_5253f275-module__E-BOkW__className",
  "variable": "geist_mono_5253f275-module__E-BOkW__variable",
});
